import axios from "axios";
import { buildAuthHeaders } from "../buildAuthHeaders";
import { rootUrl } from "../rootUrl";

const endpoint = `/client/upload-contacts`;

export const postUploadContacts = async (
  clientId: string,
  file: File,
  accessToken: string
): Promise<void> => {
  const formData = new FormData();
  formData.append("file", file);

  await axios.post(`${rootUrl}${endpoint}/${clientId}`, formData, {
    ...buildAuthHeaders(accessToken),
    headers: {
      ...buildAuthHeaders(accessToken).headers,
      "Content-Type": "multipart/form-data",
    },
  });
};
